import { z } from "zod";

export const ensuranceInput = z.object({
  firebaseAccountId: z.string(),
  countryCode: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  birthDate: z.string().optional(),
});

export type EnsuranceInput = z.infer<typeof ensuranceInput>;
